import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    playOnHover: Boolean,
  }

  connect() {
    this.node = this.element.closest('.js-builder-node')

    if (this.playOnHoverValue) {
      this.node.addEventListener('mouseenter', this.play)
      this.node.addEventListener('mouseleave', this.pause)
    }
  }

  disconnect() {
    if (this.playOnHoverValue) {
      this.node.removeEventListener('mouseenter', this.play)
      this.node.removeEventListener('mouseleave', this.pause)
    }
  }

  play = () => {
    this.element.play()
  }

  pause = () => {
    this.element.pause()
  }
}
